module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container product"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('h2', [_vm._v("Customize Your Order")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n\t\t\t\t\t\t\tEnter an inscription below to customize your\n\t\t\t\t\t\t\t"), (_vm.is12x12(_vm.product.item_image_default || '')) ? [_vm._v("\n\t\t\t\t\t\t\t\tpaver.\n\t\t\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (_vm.isTree(_vm.product.item_image_default || '')) ? [_vm._v("\n\t\t\t\t\t\t\t\tplaque. \n\t\t\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (_vm.isNook(_vm.product.item_image_default || '')) ? [_vm._v("\n\t\t\t\t\t\t\t\tplaque. \n\t\t\t\t\t\t\t")] : _vm._e(), _vm._v("\n                            Each line allows for " + _vm._s(_vm.product.max_characters) + " characters per line, including spaces and punctuation.\n                            View our "), _c('a', {
    staticClass: "text-danger underline pointer",
    on: {
      "click": function($event) {
        _vm.showInscriptionGuidelines()
      }
    }
  }, [_vm._v("inscription policy")]), _vm._v(" for more information.\n                        ")], 2), _vm._v(" "), _c('p', [_vm._v("Orders placed by Apr. 30, 2022 will be installed in Sept. 2022.")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "prod-container"
  }, [_c('img', {
    staticClass: "prod-img",
    attrs: {
      "src": _vm.getProductImage(_vm.logo)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prod-replica"
  }, [_c('div', {
    staticClass: "prod-replica-table"
  }, [_c('div', {
    staticClass: "prod-replica-table-td",
    class: _vm.product.classes
  }, _vm._l((_vm.product.max_lines), function(n) {
    return _c('p', [_vm._v(_vm._s(_vm.lines[n - 1]))])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  }), _vm._v(" "), (_vm.is12x12(_vm.product.item_image_default || '')) ? [_c('h4', [_vm._v("$ 500.00")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Paver Inscription:")])] : _vm._e(), _vm._v(" "), (_vm.isTree(_vm.product.item_image_default || '')) ? [_c('h4', [_vm._v("$ 1500.00")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Plaque Inscription:")])] : _vm._e(), _vm._v(" "), (_vm.isNook(_vm.product.item_image_default || '')) ? [_c('h4', [_vm._v("$ 5000.00")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Plaque Inscription:")])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brick-text-form"
  }, _vm._l((_vm.product.max_lines), function(n) {
    return _c('div', {
      staticClass: "form-group row no-gutter"
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_c('label', {
      attrs: {
        "for": 'l-' + n
      }
    }, [_vm._v("Line " + _vm._s(n) + ":")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "line-id": 'l-' + n,
        "id": 'l-' + n,
        "maxlength": _vm.product.max_characters,
        "size": _vm.product.max_characters
      },
      domProps: {
        "value": _vm.lines[n - 1]
      },
      on: {
        "keydown": function($event) {
          _vm.withAnyKeyDown($event)
        },
        "keyup": function($event) {
          _vm.withAnyKeyUp($event)
        },
        "input": function($event) {
          _vm.withInput($event)
        }
      }
    })])])
  })), _vm._v(" "), _c('p', [_vm._v("Need inspiration?\n                                "), _c('a', {
    staticClass: "text-danger pointer",
    on: {
      "click": function($event) {
        _vm.showInscriptionExamples()
      }
    }
  }, [_vm._v("Click here")]), _vm._v("\n                                for inscription examples.\n                            ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "red"
  }), _vm._v(" "), _c('p', [(_vm.is12x12(_vm.product.item_image_default || '')) ? [_vm._v("\n\t\t\t\t\t\t\t\t\tThis image is for representation only and is not an exact reflection of your completed product. All materials subject to change based on final architectural design. The duration of the paver installation shall be equivalent to the useful life of the facility. The paver acknowledges the donor(s) generous philanthropy and good citizenship. The public affiliation with the donor(s) name enhances the reputation of the university and inspires others to make philanthropic investments for the benefit of the university’s educational mission.  Should circumstances change in a manner that such affiliation would cause harm to the reputation of the university, the university president may request that the Board of Trustees exercise its authority to rescind paver installation.  The donor(s) may revoke the university’s right to use the name at any time.\n\t\t\t\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (_vm.isTree(_vm.product.item_image_default || '')) ? [_vm._v("\n\t\t\t\t\t\t\t\t\tThis image is for representation only and is not an exact reflection of your completed product. All materials subject to change based on final architectural design. The duration of the plaque installation shall be equivalent to the useful life of the facility. The plaque acknowledges the donor(s) generous philanthropy and good citizenship. The public affiliation with the donor(s) name enhances the reputation of the university and inspires others to make philanthropic investments for the benefit of the university’s educational mission.  Should circumstances change in a manner that such affiliation would cause harm to the reputation of the university, the university president may request that the Board of Trustees exercise its authority to rescind plaque installation.  The donor(s) may revoke the university’s right to use the name at any time.\n\t\t\t\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (_vm.isNook(_vm.product.item_image_default || '')) ? [_vm._v("\n\t\t\t\t\t\t\t\t\tThis image is for representation only and is not an exact reflection of your completed product. All materials subject to change based on final architectural design. The duration of the plaque installation shall be equivalent to the useful life of the facility. The plaque acknowledges the donor(s) generous philanthropy and good citizenship. The public affiliation with the donor(s) name enhances the reputation of the university and inspires others to make philanthropic investments for the benefit of the university’s educational mission.  Should circumstances change in a manner that such affiliation would cause harm to the reputation of the university, the university president may request that the Board of Trustees exercise its authority to rescind plaque installation.  The donor(s) may revoke the university’s right to use the name at any time.\n\t\t\t\t\t\t\t\t")] : _vm._e()], 2)])]), _vm._v(" "), (_vm.isMultiLogoAllowed) ? _c('preferred-logo', {
    ref: "preflog",
    attrs: {
      "options": _vm.product.options || {},
      "logo": _vm.logo,
      "on-logo-change": "onProductLogoChange"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.item_id > 0) ? void 0 : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "btn-wrap"
  }, [_c('a', {
    staticClass: "btn btn-danger btn-lg pull-right",
    attrs: {
      "disabled": _vm.item_id == 0
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("Add to cart")])])])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c2062c5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/Product.vue
// module id = Rydz
// module chunks = 1